import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import PrintSummaryReport from './PrintSummaryReport';
import MomentInfoPrint from './MomentInfoPrint';
import SkeletonInfo from './SkeletonInfo';
import Map from './Map';
import ObjectStops from './Map/ObjectStops';
import StickyButtonContainer from './StickyButtonContainer.js';

const useStyles = makeStyles({
  container: {
    height: '50%',
    display: 'flex',
    'align-items': 'stretch',
    '@media (orientation: portrait)': {
      flexDirection: `column`,
    },
  },
  subContainer: {
    width: '100%',
    height: '50%',
  },
  info: {
    //width: '300px',
    flexGrow: 1,
    flexBasis: 0,
    '@media (orientation: portrait)': {
      width: '100%',
    },
  },
  map: {
    'flex-grow': 2,
    '-webkit-flex-grow': 2,
    display: 'flex',
  },
  printButton: {
    opacity: 0.3,
    position: 'absolute',
    left: 10,
    bottom: 10,
    zIndex: 1000,
    '&:hover': {
      opacity: 1,
    },
  },
});

const MapPrintSummaryReport = ({
  object = {},
  addressMap,
  loading,
  disableButton = false,
  options,
  onSelectItem,
  printType,
  onPrint,
  index,
}) => {
  if (!object) {
    throw new Error('Object value must not be set to null or undefined!');
  }
  const classes = useStyles();
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });
  const orientation = isPortrait ? 'horizontal' : 'vertical';
  const driverNameRef = React.useRef('');

  const printData = object.print;
  const mapData = object.map;
  const objectName = object.objectName;

  const handleDriverInput = event => {
    driverNameRef.current = event.currentTarget.value;
  };

  return (
    <Box height={1} width={1}>
      <Box height={1} className={classes.container}>
        <Box className={classes.info}>
          <Paper
            style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
          >
            {loading ? (
              <SkeletonInfo orientation={orientation} />
            ) : (
              <MomentInfoPrint
                name={objectName}
                start={new Date(object.start)}
                end={new Date(object.end)}
                startDist={object.print.startDist}
                endDist={object.print.endDist}
                totalDist={object.print.totalDist}
                totalRest={object.print.totalRest}
                totalWork={object.print.totalWork}
                overtime={object.print.overtime}
                orientation={orientation}
                onDriverInput={handleDriverInput}
              />
            )}
          </Paper>
        </Box>
        <Box className={classes.map}>
          <Paper style={{ flex: 1 }}>
            {loading ? (
              <Map></Map>
            ) : (
              <Map>
                <ObjectStops data={mapData} select={index}/>
              </Map>
            )}
          </Paper>
        </Box>
      </Box>
      <Box className={classes.subContainer}>
        <Paper style={{ width: '100%', height: '100%', position: 'relative' }}>
          <StickyButtonContainer
            text='Принтирай'
            onClick={onPrint}
            disableButton={disableButton}
          >
            <PrintSummaryReport
              id={'print-report'}
              object={printData}
              addressMap={addressMap}
              loading={loading}
              onSelectItem={onSelectItem}
              options={options && options.print}
            />
          </StickyButtonContainer>
        </Paper>
      </Box>
    </Box>
  );
};

MapPrintSummaryReport.propTypes = {
  object: PropTypes.object,
  addressMap: PropTypes.object,
  loading: PropTypes.bool,
  disableButton: PropTypes.bool,
  options: PropTypes.object,
};

export default MapPrintSummaryReport;
